import { RouteTypes } from 'consts';
import Header from 'containers/Header';
import InstructorsContainer from 'containers/instructorContainer';
import JourneysContainer from 'containers/journeysContainer';
import { ObservationsContainer } from 'containers/observationsContainer';
import PracticeInformation from 'containers/practiceInformation';
import { PreparationTimeContainer } from 'containers/preparationTimeContainer';
import ServicesContainer from 'containers/servicesContainer';
import StationsContainer from 'containers/stationContainer';
import { PracticeFormLegend } from 'pages/CreatePractice/PracticeFormLegend/PracticeFormLegend';
import { ReactElement, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory,useParams } from 'react-router-dom';
import {
  RfUiBreadcrumbs,
  RfUiButton,
  RfUiInput,
  RfUiModal,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  resetCreatePracticeForm,
  setIsAuditar,
  setModalDraftType,
  setMsgSubmit,
  setObservacionesAlumno,
  setObservacionesInstructor,
  setPracticaEditar,
  setStateType,
} from 'store/app/actions';
import {
  makeSelectCanCreateDraft,
  makeSelectCanCreatePractice,
  makeSelectCourseCreateSelected,
  makeSelectFinishDateTimeSelectedJourney,
  makeSelectFinishDateTimeSelectedService,
  makeSelectIdTypePracticeSelected,
  makeSelectInstructorsSelected,
  makeSelectIsThereIsAnErrorInJourneySelected,
  makeSelectIsThereIsAnErrorInServiceSelected,
  makeSelectMinutesPracticeSelected,
  makeSelectMinutesPracticeSelectedError,
  makeSelectModalDraftType,
  makeSelectMsgSubmit,
  makeSelectNumTurnoSelected,
  makeSelectObservacionesAlumno,
  makeSelectObservacionesInstructor,
  makeSelectPracticaCreada,
  makeSelectStartDateTimeSelectedJourney,
  makeSelectStartDateTimeSelectedService,
  makeSelectStateType,
  makeSelectStationFinSelected,
  makeSelectStationIniSelected,
  makeSelectTrainSelected,
  makeSelectTypeServiceSelected,
  makeSelectVehicleSelected,
} from 'store/app/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  crearPracticaRequest,
  postAnularPracticaRequest,
  postAuditoriaEditRequest,
  postRechazarPracticaEditRequest,
  postReclamarPracticaRequest,
  postValidarPracticaRequest,
  resetPracticaSeleccionada,
} from 'store/practicas/actions';
import { makeSelectPracticaSeleccionada, makeSelectPracticasList } from 'store/practicas/selectors';
import { getAlumnPortraitRequest } from 'store/usuarios/actions';
import {
  makeSelectGetAlumnPhoto,
  makeSelectIsFormadorProfile,
  makeSelectIsInstructorProfile,
  makeSelectIsManagerProfile,
  makeSelectIsProfileActive,
  makeSelectIsStudentProfile,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectIsAdministradorProfile,
  makeSelectIsViewerProfile,
} from 'store/usuarios/selectors';
import { language } from 'utils/literals';
import { stateLiteral } from 'utils/statesLiterals';
import './practice-detail.scss';

const selectors = createStructuredSelector({
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  practicaSeleccionada: makeSelectPracticaSeleccionada(),
  selectedCourse: makeSelectCourseCreateSelected(),
  stationFin: makeSelectStationFinSelected(),
  instructor: makeSelectInstructorsSelected(),
  stationIni: makeSelectStationIniSelected(),
  numTren: makeSelectTrainSelected(),
  numTurno: makeSelectNumTurnoSelected(),
  idTypePractice: makeSelectIdTypePracticeSelected(),
  typeService: makeSelectTypeServiceSelected(),
  vehiculo: makeSelectVehicleSelected(),
  statePractice: makeSelectStateType(),
  practicaCreada: makeSelectPracticaCreada(),
  startJourneySelected: makeSelectStartDateTimeSelectedJourney(),
  finishJourneySelected: makeSelectFinishDateTimeSelectedJourney(),
  startServiceSelected: makeSelectStartDateTimeSelectedService(),
  finishServiceSelected: makeSelectFinishDateTimeSelectedService(),
  isErrorInJourney: makeSelectIsThereIsAnErrorInJourneySelected(),
  isErrorInService: makeSelectIsThereIsAnErrorInServiceSelected(),
  minutesPracticeSelected: makeSelectMinutesPracticeSelected(),
  minutesPracticeSelectedError: makeSelectMinutesPracticeSelectedError(),
  alumnPhoto: makeSelectGetAlumnPhoto(),
  canCreateDraft: makeSelectCanCreateDraft(),
  canCreatePractice: makeSelectCanCreatePractice(),
  observaciones_instructor: makeSelectObservacionesInstructor(),
  observaciones_alumno: makeSelectObservacionesAlumno(),
  isProfileActive: makeSelectIsProfileActive(),
  isStudentProfile: makeSelectIsStudentProfile(),
  isInstructorProfile: makeSelectIsInstructorProfile(),
  isManagerProfile: makeSelectIsManagerProfile(),
  isViewerProfile: makeSelectIsViewerProfile(),
  isFormadorProfile: makeSelectIsFormadorProfile(),
  isAdministradorProfile: makeSelectIsAdministradorProfile(),
  practicas: makeSelectPracticasList()
} as any);

const PracticeDetail = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<any>();
  const links = [
    {
      label: 'Listado de prácticas',
      link: RouteTypes.HOME,
      textHelp: 'Listado de prácticas',
      active: false,
    },
    {
      label: `Detalle de práctica ${id}`,
      link: '#',
      textHelp: `Detalle de práctica ${id}`,
      active: true,
    },
  ];
  const {
    profileActive,
    practicaSeleccionada,
    access_token,
    msgSubmit,
    modalDraftType,
    alumnPhoto,
    canCreateDraft,
    canCreatePractice,
    observaciones_instructor,
    observaciones_alumno,
    isProfileActive,
    isStudentProfile,
    isInstructorProfile,
    isManagerProfile,
    isViewerProfile,
    isFormadorProfile,
    isAdministradorProfile,
    practicas
  } = useSelector<any, any>(selectors);

  useEffect(() => {
    if (
      profileActive &&
      practicaSeleccionada &&
      Object.keys(practicaSeleccionada).length
    ) {
      dispatch(
        getAlumnPortraitRequest(practicaSeleccionada.CABECERA_FICHA.ID_ALUMNO)
      );
    }
  }, [profileActive, practicaSeleccionada]);

  //Modal
  const [modalTypeReject, setModalTypeReject] = useState<string>('');

  useEffect(() => {
    dispatch(resetCreatePracticeForm());
    dispatch(resetPracticaSeleccionada());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setIsAuditar('false'));
    };
  }, []);

  useEffect(() => {
    if (id && profileActive?.ID_PERFIL) {
      dispatch(setPracticaEditar(id));
    }
  }, [dispatch, id, profileActive]);

  // Botones de Anterior/Siguiente práctica
  const [isPrevDisabled, setIsPrevDisabled] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  useEffect(() => {
    // Actualiza el estado que habilita o deshabilita los botones si existe una anterior o siguiente práctica
    const currentPracticeId = Number(id);
    const listPractices = practicas.map(el => el.ID_PRACTICA);
    const currentIndex = listPractices.indexOf(currentPracticeId);

    if (currentIndex <= 0) {
      setIsPrevDisabled(true);
    } else {
      setIsPrevDisabled(false);
    }

    if (currentIndex >= listPractices.length - 1) {
      setIsNextDisabled(true);
    } else {
      setIsNextDisabled(false);
    }
  }, [id, practicas]);

  const botonPrev = (practicas, history) => {
    const currentPracticeId = Number(id);
    const listPractices = practicas.map(el => el.ID_PRACTICA);
    const currentIndex = listPractices.indexOf(currentPracticeId);

    if (currentIndex === -1) {
      return;
    }

    const prevPracticeId = currentIndex > 0
      ? listPractices[currentIndex - 1]
      : null;

    if (prevPracticeId !== null) {
      history.push({
        pathname: `/practice/detail/${prevPracticeId}`,
        state: { practicaSeleccionada: prevPracticeId }
      });
    }
  };

  const botonNext = (practicas, history) => {
    const currentPracticeId = Number(id);
    const listPractices = practicas.map(el => el.ID_PRACTICA);
    const currentIndex = listPractices.indexOf(currentPracticeId);

    if (currentIndex === -1) {
      return;
    }

    const nextPracticeId = currentIndex < listPractices.length - 1
      ? listPractices[currentIndex + 1]
      : null;

    if (nextPracticeId !== null) {
      history.push({
        pathname: `/practice/detail/${nextPracticeId}`,
        state: { practicaSeleccionada: nextPracticeId }
      });
    }
  };

  // Mostrar botones

  const showCancelPracticeButton: boolean = useMemo(() => {
    return (
      isStudentProfile &&
      isProfileActive &&
      (practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.borrador ||
        practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.pendCorrecion)
    );
  }, [isStudentProfile, isProfileActive, practicaSeleccionada]);

  const showEditDraftButton: boolean = useMemo(() => {
    const estadoPractica =
      practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ?? '';
    return (
      isStudentProfile &&
      isProfileActive &&
      [stateLiteral.borrador, stateLiteral.pendCorrecion].indexOf(
        estadoPractica
      ) > -1
    );
  }, [
    isStudentProfile,
    isProfileActive,
    practicaSeleccionada,
    observaciones_instructor,
  ]);

  const showEditPracticeButton: boolean = useMemo(() => {
    const estadoPractica =
      practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ?? '';
    return (
      isStudentProfile &&
      isProfileActive &&
      [stateLiteral.borrador, stateLiteral.pendCorrecion].indexOf(
        estadoPractica
      ) > -1
    );
  }, [
    isStudentProfile,
    isProfileActive,
    practicaSeleccionada,
    observaciones_instructor,
  ]);

  const showRejectPracticeButton: boolean = useMemo(() => {
    return (
      ((isInstructorProfile || isFormadorProfile) &&
        isProfileActive &&
        (practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
          stateLiteral.pendValidar ||
          practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
          stateLiteral.reclamada)) ||
      (isManagerProfile &&
        practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.validada)
    );
  }, [
    isInstructorProfile,
    isProfileActive,
    isManagerProfile,
    isFormadorProfile,
    practicaSeleccionada,
  ]);

  const showValidatePracticeButton: boolean = useMemo(() => {
    return (
      (isAdministradorProfile ||
      isFormadorProfile ||
      isInstructorProfile) &&
      isProfileActive &&
      (practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.pendValidar ||
        practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.reclamada)
    );
  }, [isInstructorProfile, isAdministradorProfile, isFormadorProfile, isProfileActive, practicaSeleccionada]);

  const showAuditPracticeButton: boolean = useMemo(() => {
    return (
      isManagerProfile &&
      (practicaSeleccionada?.CUERPO_FICHA?.FECHA_AUDITORIA === null ||
        practicaSeleccionada?.CUERPO_FICHA?.FECHA_AUDITORIA === 0)
    );
  }, [isManagerProfile, practicaSeleccionada]);

  const showClaimPracticeButton: boolean = useMemo(() => {
    return (
      isManagerProfile &&
      (practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.pendValidar ||
        practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ===
        stateLiteral.reclamada)
    );
  }, [isManagerProfile, practicaSeleccionada]);

  // Habilitar campos y botones

  const isObservacionesAlumnoDisabled: boolean = useMemo(() => {
    return (
      isManagerProfile ||
      isInstructorProfile ||
      isViewerProfile ||
      (isStudentProfile &&
        practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA !==
        stateLiteral.borrador &&
        practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA !==
        stateLiteral.pendCorrecion)
    );
  }, [
    isManagerProfile,
    isInstructorProfile,
    isStudentProfile,
    practicaSeleccionada,
  ]);

  const isObservacionesInstructorDisabled: boolean = useMemo(() => {
    const estadoPractica =
      practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA ?? '';
    return (
      (isManagerProfile && estadoPractica === stateLiteral.validada) ||
      ((isInstructorProfile || isFormadorProfile) &&
        (estadoPractica === stateLiteral.pendValidar ||
          estadoPractica === stateLiteral.reclamada))
    );
  }, [
    isManagerProfile,
    isFormadorProfile,
    isInstructorProfile,
    practicaSeleccionada,
  ]);

  const profileCanCancelPractice: boolean = useMemo(() => {
    return isProfileActive;
  }, [isProfileActive]);

  const profileCanEditDraft: boolean = useMemo(() => {
    return canCreateDraft;
  }, [canCreateDraft]);

  const profileCanRejectPractice: boolean = useMemo(() => {
    return !!observaciones_instructor;
  }, [observaciones_instructor]);

  const profileCanEditPractice: boolean = useMemo(() => {
    return canCreatePractice;
  }, [canCreatePractice]);

  const profileCanValidatePractice: boolean = useMemo(() => {
    return isProfileActive;
  }, [isProfileActive]);

  const profileCanAuditPractice: boolean = useMemo(() => {
    return isProfileActive;
  }, [isProfileActive]);

  const profileCanClaimPractice: boolean = useMemo(() => {
    return isProfileActive;
  }, [isProfileActive]);

  // Eventos

  const handleChangeObservacionesAlumno = (e: string) => {
    dispatch(setObservacionesAlumno(e));
  };

  const handleChangeObservacionesInstructor = (e: string) => {
    dispatch(setObservacionesInstructor(e));
  };

  const handleClickCancelPracticeButton = () => {
    dispatch(postAnularPracticaRequest());
    dispatch(resetCreatePracticeForm());
    dispatch(resetPracticaSeleccionada());
  };

  const handleClickEditDraftButton = () => {
    dispatch(setStateType(stateLiteral.borrador));
    dispatch(crearPracticaRequest());
    checkRedirect();
  };

  const handleClickRejectPracticeButton = () => {
    setModalTypeReject('confirm');
  };

  const handleModalCloseRejectPractice = () => {
    setModalTypeReject('');
  };

  const handleModalConfirmRejectPractice = () => {
    dispatch(setMsgSubmit('Estas seguro de querer rechazar la práctica?'));
    dispatch(postRechazarPracticaEditRequest());
  };

  const handleClickEditPracticeButton = () => {
    dispatch(setStateType(stateLiteral.pendValidar));
    dispatch(crearPracticaRequest());
  };

  const handleClickValidatePracticeButton = () => {
    dispatch(postValidarPracticaRequest());
  };

  const handleClickAuditPracticeButton = () => {
    dispatch(postAuditoriaEditRequest());
    dispatch(resetCreatePracticeForm());
    history.push(RouteTypes.HOME);
  };

  const handleClickClaimPracticeButton = () => {
    dispatch(postReclamarPracticaRequest());
  };

  const handleModalCloseEditDraft = () => {
    dispatch(setModalDraftType(''));
    checkRedirect();
  };

  const checkRedirect = () => {
    if (modalDraftType === 'success') {
      dispatch(resetCreatePracticeForm());
      if (id && profileActive?.ID_PERFIL) {
        dispatch(resetPracticaSeleccionada());
        dispatch(setPracticaEditar(id));
      }
    }
    setModalDraftType('');
  };

  // Confirmar acceso a la página

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  if (practicaSeleccionada.STATUS && practicaSeleccionada.STATUS === 'KO') {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  // Datos usuario validador
  const isPracticaValidada = practicaSeleccionada?.CUERPO_FICHA?.ID_ESTADO_PRACTICA === stateLiteral.validada;
  const hasUsuarioValidador = practicaSeleccionada?.CUERPO_FICHA?.USUARIO_VALIDADOR !== null;

  return (
    <>
      <Header />
      <div className="rf-layout rf-layout__desktop">
        {links && (
          <RfUiBreadcrumbs
            links={JSON.stringify(links)}
            onEventChange={(e: any) => {
              history.push(e.detail);
            }}
          ></RfUiBreadcrumbs>
        )}
        <div className="rf-practice-detail__title-container rf-flex rf-justify-space" >
          <div>
            <h1 className="rf-title rf-title--simple">
              {language.informacionPractica.detallePractica}
            </h1>
          </div>
          <div className='rf-flex'>
            <RfUiButton
              text={"Anterior"}
              disabled={isPrevDisabled}
              onButtonClick={() => botonPrev(practicas, history)}
            >
            </RfUiButton>
            <RfUiButton
              text={"Siguiente"}
              disabled={isNextDisabled}
              onButtonClick={() => botonNext(practicas, history)}
            >
            </RfUiButton>
          </div>
        </div>
        {isStudentProfile && (
          <div>
            <h2 className="rf-title rf-title--secundary rf-title--hide-mobile">
              {language.informacionPractica.alumnoLabel}
            </h2>
            <div className="rf-container-box">
              <div className="rf-box--user">
                <div>
                  <div className="rf-box__child">
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.alumnoNombre}
                        error=""
                        className="rf-input"
                        disabled
                        value={
                          practicaSeleccionada?.CABECERA_FICHA?.ID_ALUMNO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.NOMBRE_ALUMNO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.cursoLabel}
                        error=""
                        className="rf-input"
                        disabled
                        value={
                          practicaSeleccionada?.CABECERA_FICHA?.ID_CURSO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.NOMBRE_CURSO
                        }
                      ></RfUiInput>
                    </div>
                    {/* <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.sociedadCursoLabel}
                        error=""
                        className="rf-input"
                        disabled
                        value={
                          practicaSeleccionada?.CABECERA_FICHA
                            ?.ID_SOCIEDAD_CURSO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.SOCIEDAD_CURSO
                        }
                      ></RfUiInput>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {(isManagerProfile || isInstructorProfile || isViewerProfile) && (
          <div>
            <h2 className="rf-title rf-title--secundary rf-title--hide-mobile">
              {language.informacionPractica.alumnoLabel}
            </h2>
            <div className="rf-container-box">
              <div className="rf-box--user">
                <div>
                  <div className="rf-box__child">
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.alumnoNombre}
                        error=""
                        className="rf-input"
                        disabled
                        value={
                          practicaSeleccionada?.CABECERA_FICHA?.ID_ALUMNO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.NOMBRE_ALUMNO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.alumnoTipo}
                        error=""
                        className="rf-input"
                        disabled
                        value={
                          practicaSeleccionada?.CABECERA_FICHA
                            ?.TIPO_PERFIL_ALUMNO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.provincia}
                        error=""
                        className="rf-input"
                        disabled
                        value={practicaSeleccionada?.CABECERA_FICHA?.PROVINCIA}
                      ></RfUiInput>
                    </div>
                  </div>
                  {isManagerProfile && (
                    <div className="rf-box__child rf-practice-detail__alumn-photo-container">
                      <img alt="foto-usuario" src={alumnPhoto} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div>
          <div className="rf-box">
            <JourneysContainer />
            <PreparationTimeContainer />
            <ServicesContainer />
            <StationsContainer />
            <InstructorsContainer />
          </div>
          <div className="rf-box">
            <h2 className="rf-title rf-title--secundary">
              {language.informacionPractica.validacionLabel}
            </h2>
            <div className="rf-practice-create__input-container">
              <RfUiInput
                label={language.informacionPractica.estadoLabel}
                error=""
                className="rf-input"
                disabled
                value={
                  practicaSeleccionada?.CUERPO_FICHA?.NOMBRE_ESTADO_PRACTICA
                }
              ></RfUiInput>
              {isPracticaValidada && hasUsuarioValidador && (
                  <div><small>Validada por: {practicaSeleccionada?.CUERPO_FICHA?.USUARIO_VALIDADOR} / {practicaSeleccionada?.CUERPO_FICHA?.PERFIL_USUARIO_VALIDADOR} / {practicas.filter((el) => el.ID_PRACTICA === practicaSeleccionada?.CUERPO_FICHA?.ID_PRACTICA).map((el) => el.FECHA_ACT_ESTADO_DATE)}</small></div>
              )}
            </div>
            <div className="rf-flex rf-justify-end rf-wrap rf-align-center rf-text-align-right rf-block--mobile rf-text-align-center--mobile rf-margin-bottom-15">
              {showCancelPracticeButton && (
                <div className="rf-practice-detail__input-container rf-margin-right-15">
                  <RfUiButton
                    disabled={!profileCanCancelPractice}
                    text={language.informacionPractica.anularLabel}
                    type="button"
                    aspect="white"
                    className="rf-button"
                    onButtonClick={handleClickCancelPracticeButton}
                  ></RfUiButton>
                </div>
              )}
              {showEditDraftButton && (
                <div className="rf-practice-detail__input-container rf-margin-right-15">
                  <RfUiButton
                    disabled={!profileCanEditDraft}
                    text={language.informacionPractica.grabarBorradorLabel}
                    type="button"
                    aspect="white"
                    className="rf-button"
                    onButtonClick={handleClickEditDraftButton}
                  />
                </div>
              )}
              {showRejectPracticeButton && (
                <div className="rf-practice-detail__input-container rf-margin-right-15">
                  <RfUiButton
                    disabled={!profileCanRejectPractice}
                    text={language.informacionPractica.rechazarLabel}
                    type="button"
                    aspect="white"
                    className="rf-button"
                    onButtonClick={handleClickRejectPracticeButton}
                  />
                </div>
              )}
              {showEditPracticeButton && (
                <div className="rf-practice-detail__input-container rf-margin-right-15">
                  <RfUiButton
                    disabled={!profileCanEditPractice}
                    text={language.informacionPractica.enviarLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button"
                    onButtonClick={handleClickEditPracticeButton}
                  />
                </div>
              )}
              {showValidatePracticeButton && (
                <div className="rf-practice-detail__input-container rf-margin-right-15">
                  <RfUiButton
                    disabled={!profileCanValidatePractice}
                    text={language.informacionPractica.validarLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button"
                    onButtonClick={handleClickValidatePracticeButton}
                  />
                </div>
              )}
              {/* Button Audit practice: profile "formador,gestor,administrador". enabled for unaudited */}
              {showAuditPracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanAuditPractice}
                    text={language.informacionPractica.auditLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button rf-margin-right-15"
                    onButtonClick={handleClickAuditPracticeButton}
                  />
                </div>
              )}
              {showClaimPracticeButton && (
                <div className="rf-practice-detail__input-container rf-margin-right-15">
                  <RfUiButton
                    disabled={!profileCanClaimPractice}
                    text={language.informacionPractica.reclamarLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button"
                    onButtonClick={handleClickClaimPracticeButton}
                  />
                </div>
              )}
            </div>
            <PracticeFormLegend />
            <PracticeInformation />
          </div>
          <ObservationsContainer
            title={language.informacionPractica.observacionesInstructorLabel}
            disableObservationAlumn={!isObservacionesInstructorDisabled}
            valueObservation={observaciones_instructor}
            handleObservationsChange={handleChangeObservacionesInstructor}
          />

          <ObservationsContainer
            title={language.informacionPractica.observationsAlumnLabel}
            disableObservationAlumn={isObservacionesAlumnoDisabled}
            valueObservation={observaciones_alumno}
            handleObservationsChange={handleChangeObservacionesAlumno}
          />
        </div>
        <RfUiModal
          title-modal={msgSubmit}
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={handleModalCloseEditDraft}
        ></RfUiModal>
        <RfUiModal
          title-modal={language.informacionPractica.modalConfirmRechazar}
          id-modal="modalReject"
          modal-type={modalTypeReject}
          onModalClose={handleModalCloseRejectPractice}
          onConfirm={handleModalConfirmRejectPractice}
        ></RfUiModal>
      </div>

      <div className="rf-layout rf-layout__mobile">
        {links && (
          <RfUiBreadcrumbs
            links={JSON.stringify(links)}
            onEventChange={(e: any) => {
              history.push(e.detail);
            }}
          ></RfUiBreadcrumbs>
        )}
        <div className="rf-practice-detail__title-container">
          <h1 className="rf-title rf-title--simple">
            {language.informacionPractica.detallePractica}
          </h1>
        </div>
        {isStudentProfile && (
          <div>
            <h2 className="rf-title rf-title--secundary rf-title--hide-mobile">
              {language.informacionPractica.alumnoLabel}
            </h2>
            <div className="rf-container-box">
              <div className="rf-box--user">
                <div>
                  <div className="rf-box__child">
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.alumnoNombre}
                        error=""
                        className="rf-input"
                        disabled={true}
                        value={
                          practicaSeleccionada?.CABECERA_FICHA?.ID_ALUMNO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.NOMBRE_ALUMNO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.cursoLabel}
                        error=""
                        className="rf-input"
                        disabled={true}
                        value={
                          practicaSeleccionada?.CABECERA_FICHA?.ID_CURSO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.NOMBRE_CURSO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.sociedadCursoLabel}
                        error=""
                        className="rf-input"
                        disabled={true}
                        value={
                          practicaSeleccionada?.CABECERA_FICHA
                            ?.ID_SOCIEDAD_CURSO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.SOCIEDAD_CURSO
                        }
                      ></RfUiInput>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {(isManagerProfile || isInstructorProfile) && (
          <div>
            <h2 className="rf-title rf-title--secundary rf-title--hide-mobile">
              {language.informacionPractica.alumnoLabel}
            </h2>
            <div className="rf-container-box">
              <div className="rf-box--user">
                <div>
                  <div className="rf-box__child">
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.alumnoNombre}
                        error=""
                        className="rf-input"
                        disabled={true}
                        value={
                          practicaSeleccionada?.CABECERA_FICHA?.ID_ALUMNO +
                          ' - ' +
                          practicaSeleccionada?.CABECERA_FICHA?.NOMBRE_ALUMNO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.alumnoTipo}
                        error=""
                        className="rf-input"
                        disabled={true}
                        value={
                          practicaSeleccionada?.CABECERA_FICHA
                            ?.TIPO_PERFIL_ALUMNO
                        }
                      ></RfUiInput>
                    </div>
                    <div className="rf-practice-create__input-container">
                      <RfUiInput
                        label={language.informacionPractica.provincia}
                        error=""
                        className="rf-input"
                        disabled={true}
                        value={practicaSeleccionada?.CABECERA_FICHA?.PROVINCIA}
                      ></RfUiInput>
                    </div>
                  </div>
                  {isManagerProfile && (
                    <div className="rf-box__child rf-practice-detail__alumn-photo-container">
                      <img alt="foto-usuario" src={alumnPhoto} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div>
          <div className="rf-box">
            <JourneysContainer />
            <PreparationTimeContainer />
            <ServicesContainer />
            <StationsContainer />
            <InstructorsContainer />
            <PracticeInformation />
          </div>
          <ObservationsContainer
            title={language.informacionPractica.observacionesInstructorLabel}
            disableObservationAlumn={!isObservacionesInstructorDisabled}
            valueObservation={observaciones_instructor}
            handleObservationsChange={handleChangeObservacionesInstructor}
          />

          <ObservationsContainer
            title={language.informacionPractica.observationsAlumnLabel}
            disableObservationAlumn={isObservacionesAlumnoDisabled}
            valueObservation={observaciones_alumno}
            handleObservationsChange={handleChangeObservacionesAlumno}
          />
          <div className="rf-box">
            <h2 className="rf-title rf-title--secundary">
              {language.informacionPractica.validacionLabel}
            </h2>
            <div className="rf-practice-create__input-container">
              <RfUiInput
                label={language.informacionPractica.estadoLabel}
                error=""
                className="rf-input"
                disabled={true}
                value={
                  practicaSeleccionada?.CUERPO_FICHA?.NOMBRE_ESTADO_PRACTICA
                }
              ></RfUiInput>
              {isPracticaValidada && hasUsuarioValidador && (
                  <div><small>Validada por: {practicaSeleccionada?.CUERPO_FICHA?.USUARIO_VALIDADOR} / {practicaSeleccionada?.CUERPO_FICHA?.PERFIL_USUARIO_VALIDADOR} / {practicas.filter((p) => p.ID_PRACTICA === practicaSeleccionada?.CUERPO_FICHA?.ID_PRACTICA).map((p) => p.FECHA_ACT_ESTADO_DATE)}</small></div>
              )}
            </div>
            <div className="rf-flex rf-justify-end rf-align-center rf-text-align-right rf-block--mobile rf-text-align-center--mobile rf-margin-bottom-30">
              {showCancelPracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanCancelPractice}
                    text={language.informacionPractica.anularLabel}
                    type="button"
                    aspect="white"
                    className="rf-button"
                    onButtonClick={handleClickCancelPracticeButton}
                  ></RfUiButton>
                </div>
              )}
              {showEditDraftButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanEditDraft}
                    text={language.informacionPractica.grabarBorradorLabel}
                    type="button"
                    aspect="white"
                    className="rf-button"
                    onButtonClick={handleClickEditDraftButton}
                  />
                </div>
              )}
              {showRejectPracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanRejectPractice}
                    text={language.informacionPractica.rechazarLabel}
                    type="button"
                    aspect="white"
                    className="rf-button"
                    onButtonClick={handleClickRejectPracticeButton}
                  ></RfUiButton>
                </div>
              )}
              {showEditPracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanEditPractice}
                    text={language.informacionPractica.enviarLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button"
                    onButtonClick={handleClickEditPracticeButton}
                  ></RfUiButton>
                </div>
              )}
              {showValidatePracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanValidatePractice}
                    text={language.informacionPractica.validarLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button"
                    onButtonClick={handleClickValidatePracticeButton}
                  />
                </div>
              )}
              {/* Button Audit practice: profile "formador,gestor,administrador". enabled for unaudited */}
              {showAuditPracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanAuditPractice}
                    text={language.informacionPractica.auditLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button rf-margin-right-15"
                    onButtonClick={handleClickAuditPracticeButton}
                  />
                </div>
              )}
              {showClaimPracticeButton && (
                <div className="rf-practice-detail__input-container">
                  <RfUiButton
                    disabled={!profileCanClaimPractice}
                    text={language.informacionPractica.reclamarLabel}
                    type="button"
                    aspect="primary"
                    className="rf-button"
                    onButtonClick={handleClickClaimPracticeButton}
                  />
                </div>
              )}
            </div>
            <PracticeFormLegend />
          </div>
        </div>
        <RfUiModal
          title-modal={msgSubmit}
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={handleModalCloseEditDraft}
        ></RfUiModal>
        <RfUiModal
          title-modal={language.informacionPractica.modalConfirmRechazar}
          id-modal="modalReject"
          modal-type={modalTypeReject}
          onModalClose={handleModalCloseRejectPractice}
          onConfirm={handleModalConfirmRejectPractice}
        ></RfUiModal>
      </div>
    </>
  );
};

export default PracticeDetail;
